import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

import FormGroup from "../../common/components/form/FormGroup";
import { GenericSettings, GenericSettingsApiKey } from "./SystemSettings";
import { updateSystemSetting } from "./systemSettingsApi";

interface GenericSettingsFormProps {
  genericSettings: GenericSettings;
}

export default function GenericSettingsForm(props: GenericSettingsFormProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<GenericSettings>({
    defaultValues: {
      ...props.genericSettings,
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: GenericSettings) => {
    setIsLoading(true);
    await updateSystemSetting(GenericSettingsApiKey.CategoryAiSearchEnabled, `${data.categoryAiSearchEnabled}`);
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup label="Cautare AI pentru categorii" inline errorMessage={errors.categoryAiSearchEnabled?.message}>
        <Controller
          name="categoryAiSearchEnabled"
          control={control}
          render={({ field }) => <InputSwitch checked={field.value} onChange={(e) => field.onChange(e.value)} />}
        ></Controller>
      </FormGroup>
      <Button type="submit" className="block ml-auto" label="Salveaza" icon="pi pi-save" loading={isLoading} disabled={isLoading} />
    </form>
  );
}
